import i18next from "i18next";
export const language = i18next.language;
